import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanDescription',
})
export class CleanDescriptionPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) return '';

    // Elimina ObjectId de Mongo al final del texto
    return value.replace(/\s[a-f0-9]{24}$/i, '');
  }
}
